import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import { Check } from "lucide-react";
import { X } from "lucide-react";

export const Toast = ({ show, message, type = "error", onClose }) =>
	show && (
		<motion.div
			initial={{ opacity: 0, y: -20 }}
			animate={{ opacity: 1, y: 0 }}
			exit={{ opacity: 0, y: -20 }}
			className="w-full md:w-auto fixed top-14 left-1/2 transform -translate-x-1/2 z-50 text-red-800 px-6 py-4 rounded-lg flex items-center gap-3"
		>
			<div
				className={`rounded-xl shadow-lg p-4 flex items-center gap-3 ${
					type === "success"
						? "bg-green-50 text-green-600"
						: "bg-red-50 text-red-600"
				}`}
			>
				{type === "success" ? (
					<Check className="w-5 h-5" />
				) : (
					<AlertCircle className="w-5 h-5" />
				)}
				<p>{message}</p>
				<button
					onClick={onClose}
					className="ml-4 hover:opacity-75 transition-opacity"
				>
					<X className="w-5 h-5" />
				</button>
			</div>
		</motion.div>
	);
